import React, { Component } from 'react';
import * as R from "ramda";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import { tableConfigSalesman, SAMPLE_DATA_SALESMAN } from '../config';
import { HttpStatus } from "../../../../../common/Constants";
import { fetchDataAsync } from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import { mapToObjectDDL, removeNullFields } from "../../../../../common/mapper";
import { connect } from "react-redux";
import * as ErrorAction from "../../../../../../Redux/ErrorRedux";

class SalesmanProspectReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableConfig: [],
      dataTable: [],
      dataTL: [],
      teamLead: null,
    };
  };

  componentDidMount() {
    this.setState((prevValue) => ({
      ...prevValue,
      tableConfig: tableConfigSalesman,
    }));
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(prevProps.doSearch, this.props.doSearch) && this.props.doSearch === true) {
      this.fetchDataTL(this.props.search);
    }
    if(JSON.stringify(this.props.search?.kodeCabangList) !== JSON.stringify(prevProps.search?.kodeCabangList)){
      this.setState({teamLead: null})
    }
  };

  fetchDataTL = async (data) => {
    this.props.triggerLoading();
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterSales,
      setError: this.props.setError,
      menuName: "Dashboard Level Koordinator- Laporan Statistik Prospek Per Salesman / CS",
      args: { paramFilters: { kodeCabang: data.kodeCabangList[0], userNameLead: this.props.auth?.user?.username } },
    });
    this.props.onSuccessSearch();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTL: res.data.data,
      }));
    }
    this.props.triggerLoading();
  };

  handleSearchValueChange = async (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async () => {
    this.props.triggerLoading();
    let { teamLead } = this.state;
    let { kodeCabangList, month, year, page, limit } = this.props.search;
    const request = {
      kodeCabangList,
      teamLeaderEmployeeId: teamLead?.value,
      salesEmployeeId: null,
      month,
      year
    };
    let res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanStatistikSalesCS,
      menuName: "Dashboard Koordinator - Laporan Statistik Prospek Per Salesman / CS",
      setError: this.props.setError,
      args: request,
    });

    if (res?.data?.status === HttpStatus.SUCCESS) {
      this.setState((prevValue) => ({
        ...prevValue,
        dataTable: res.data.data || [],
      }));
    }
    this.props.triggerLoading();
  };


  render() {
    return (
      <div style={{ padding: 10 }}>
        <FlexView style={{ alignItems: "center", marginBottom: "10px" }}>
          <SimpleDDL
            id="select_options_team_lead"
            box="search"
            isClearable
            name="teamLead"
            containerclassname="width width-250px"
            placeholder="Select TL"
            menuPosition="fixed"
            options={this.state.dataTL.map(item => mapToObjectDDL(item.salesLeadName, item.employeeId))}
            value={this.state.teamLead}
            onChange={(value, { name }) => this.handleSearchValueChange(name, value)}
          />
          <SimpleButton onClick={this.fetchData} styles={{ marginBottom: '15px' }}>CARI</SimpleButton>
        </FlexView>
        <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>LAPORAN STATISTIK PROSPEK PER SALESMAN / CS</p>
        <SimpleDataTable
          data={this.state.dataTable}
          columns={this.state.tableConfig}
          rowsPerPage={5}
          page={0}
          options={{serverSide: false}}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesmanProspectReport);